module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/195-france-5f64ec1cab8204b99b38896cd82fbe93.svg";